interface CachedProfile {
  id: string;
  username: string | null;
  name: string | null;
  avatar_url: string | null;
  cachedAt: number;
}

const CACHE_KEY = 'giftmap_profile_cache';
const CACHE_DURATION = 1000 * 60 * 60; // 1 hour

export const profileCache = {
  get: (userId: string): CachedProfile | null => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (!cached) return null;
      
      const data = JSON.parse(cached) as CachedProfile;
      
      // Check if cache is for correct user and not expired
      if (data.id !== userId) return null;
      if (Date.now() - data.cachedAt > CACHE_DURATION) return null;
      
      return data;
    } catch {
      return null;
    }
  },
  
  set: (profile: Omit<CachedProfile, 'cachedAt'>): void => {
    try {
      const data: CachedProfile = {
        ...profile,
        cachedAt: Date.now(),
      };
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {
      console.warn('Failed to cache profile:', e);
    }
  },
  
  clear: (): void => {
    try {
      localStorage.removeItem(CACHE_KEY);
    } catch (e) {
      console.warn('Failed to clear profile cache:', e);
    }
  },
};
